/* eslint-disable max-len */
import { Route, Routes } from "react-router-dom";

import { PAGES_PATH } from "../../../navigation/params";
import React from "react";
import WellnessPlanPaymentContainer from "../WellnessPlanPaymentContainer/WellnessPlanPaymentContainer";
import { WellnessPlanSelectionContainer } from "..";

export interface IUserRoutingProps {
  setTitle: (data: string) => void;
  setOnBack: (data: boolean) => void;
}

// TODO: Move this file to Routing during cleanup

const WellnessPlanRoutingContainer = () => {
  return (
    <Routes>
      <Route path="/" element={<WellnessPlanSelectionContainer />} />
      <Route
        path={`${PAGES_PATH.WELLNESS_PLAN_CONFIRM_AND_PAY}/*`}
        element={<WellnessPlanPaymentContainer />}
      />
    </Routes>
  );
};

export default WellnessPlanRoutingContainer;
